import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import Image from '../../../../Core/Image';

export const Segment = styled.div`
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;

  ul {
    margin-left: 0;
  }

  &.image-banner,
  &.no-margin,
  &.features {
    margin: 0;
  }

  &.neg-margin {
    margin: 0;
  }

  &.spotlight {
    margin-top: 0.75rem;
    margin-bottom: 1.5rem;
  }
`;

export const SegmentHeader = styled.h4`
  font-size: 1.5rem;
  color: ${themeGet('colors.main-text')};
  line-height: 140%;
  font-weight: ${themeGet('fontWeights.medium')};
  margin-bottom: 1.5rem;
  ${Segment}.card-comparison & {
    font-size: 1.25rem;
  }
`;

export const Feature = styled.li`
  display: flex;
  column-gap: 1rem;
  align-items: center;
  ${Segment}.card-comparison & {
    align-items: start;
  }
`;

export const StyledSpan = styled.span`
  margin-bottom: unset;

  ${Segment}.hero & {
    font-size: 1.25rem;
  }

  ${Segment}.product-image & {
    font-size: 0.9rem;
  }
`;

export const StyledImage = styled(Image)`
  max-width: 2rem;
  max-height: 2rem;
  width: 100%;
  height: 100%;

  ${Segment}.features & {
    max-width: 1.25rem;
    max-height: 1.25rem;
  }

  ${Segment}.product-image & {
    max-width: 1rem;
    max-height: 1rem;
  }

  ${Segment}.card-comparison & {
    max-width: 1.5rem;
    max-height: 1.5rem;
  }
`;
